export function queryParams(params = null) {
  return {
    isQueryParams: true,
    values: params || {},
  };
}

export function isQueryParams(params) {
  return params?.isQueryParams;
}

export function linkTo(routeName, routeQueryParams = null) {
  return [ routeName, queryParams(routeQueryParams) ];
}
